import { render, staticRenderFns } from "./MoveToSportcomplex.vue?vue&type=template&id=450a2c68&"
import script from "./MoveToSportcomplex.vue?vue&type=script&lang=js&"
export * from "./MoveToSportcomplex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports